import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import * as React from 'react';

const SubOptionRow = ({ subOption }: any) => (
    <TableRow>
        <TableCell sx={{ backgroundColor: "#f3f3f3" }} align='left'>
            {subOption.subOptionName}
        </TableCell>
        <TableCell sx={{ backgroundColor: "#f3f3f3" }} align='center'>
            £{subOption.vatInAmount}
        </TableCell>
        <TableCell sx={{ backgroundColor: "#f3f3f3" }} align='center'>
            £{subOption.sdInAmount}
        </TableCell>
        <TableCell sx={{ backgroundColor: "#f3f3f3" }} align='center'>
            {subOption.subOptionQuantity}
        </TableCell>
        <TableCell sx={{ backgroundColor: "#f3f3f3" }} align='center'>
            £{subOption.basePrice}
        </TableCell>
        <TableCell sx={{ backgroundColor: "#f3f3f3" }} align='center'>
            £{subOption.basePrice * subOption.subOptionQuantity}
        </TableCell>
        <TableCell sx={{ backgroundColor: "#f3f3f3" }} align='center'>
            £{subOption.totalPrice}
        </TableCell>
    </TableRow>
);

export default SubOptionRow;